import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';


const getDepartmentsAPI = () => {
    return APICallingService.sendRequestForGet(url.getDepartment, (res) => {
    }, true);
}

function* getDepartments() {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDepartmentsAPI);
        if (response && response?.callBackStatus?.toLowerCase() == 'success') {
            yield put({
                type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get departments');
                yield put({ type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_SUCCESS, payload: { value: 'Failed' } });

    }


}

const createDepartmentAPI = (value) => {

    let payload = {
        "departmentName": value.departmentName ? value.departmentName : ''
    }
    return APICallingService.sendRequestForPostWithAuth(url.addDepartment, value, false, (res) => {



    }, true);

}

function* createDepartment(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createDepartmentAPI, action.payload.value);

        if (response && response?.callBackStatus?.toLowerCase() != 'failed') {
            alert('Department ' + response.data.departmentName + " Added Successfully")

            yield put({
                type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.ADD_DEPARTMENT_API_SUCCESS, payload: { value: response?.callBackStatus }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Department name already exists')
                yield put({ type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.ADD_DEPARTMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }

    }
    catch (e) {
        alert('Failed to create department')
        yield put({ type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.ADD_DEPARTMENT_API_SUCCESS, payload: { value: 'Failed' } });
    }
}


const editDepartmentPI = (value) => {
    let urlEdit = url.editDepartment + value.department_id;
    let payload = {
        "departmentName": value.departmentName ? value.departmentName : '',
        "is_active": value.is_active,
        "division_id": value.division_id
    }
    return APICallingService.sendRequestForPut(payload, urlEdit, (res) => {
    }, true);
}

function* editDepartment(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(editDepartmentPI, action.payload.value);

        if (response && response != null && response?.callBackStatus != 'Failed') {

            alert('Department ' + response.data.department_id + " Updated Successfully")
            yield put({
                type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.EDIT_DEPARTMENT_API_SUCCESS, payload: { value: response?.callBackStatus }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Department Name Already Exists')
                yield put({ type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.EDIT_DEPARTMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        alert('Failed to add Department')
        yield put({ type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.EDIT_DEPARTMENT_API_SUCCESS, payload: { value: 'Failed' } });
    }

}

const deleteDepartmentPI = (value) => {

    let urlEdit = url.editDepartment + value.department_id;


    let payload = {
        "departmentName": value.departmentName ? value.departmentName : '',
        "is_active": false
    }

    return APICallingService.sendRequestForPut(payload, urlEdit, (res) => {
    }, true);

}

function* deleteDepartment(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(deleteDepartmentPI, action.payload.value);

        if (response && response != null && response?.callBackStatus != 'Failed') {

            alert('Department ' + response.data.department_id + " Deleted Successfully")
            yield put({
                type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.DELETE_DEPARTMENT_API_SUCCESS, payload: { value: response?.callBackStatus }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to Delete department')
                yield put({ type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.DELETE_DEPARTMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.DELETE_DEPARTMENT_API_SUCCESS, payload: { value: 'Failed' } });
    }

}

export { editDepartment, createDepartment, getDepartments, deleteDepartment };
